import { render, staticRenderFns } from "./accountPage.vue?vue&type=template&id=5cb69230&scoped=true&"
import script from "./accountPage.vue?vue&type=script&lang=ts&"
export * from "./accountPage.vue?vue&type=script&lang=ts&"
import style0 from "./accountPage.vue?vue&type=style&index=0&id=5cb69230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb69230",
  null
  
)

export default component.exports